module.exports = __webpack_public_path__ + "static/media/reports_003.bd76a919.svg";